import { useState } from 'react';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { ImageDocumentStoreItem, RetrievedDocumentReferenceLink } from '@v2/components/imageHandling/types/types';
import { handleRemoveAttachment } from '@reducers/v2/imageHandlingV2/thunks/handleRemoveAttachment';
import { handleToggleFavoriteLink as handleToggleFavoriteLinkFn } from '@reducers/v2/imageHandlingV2/thunks';

interface UseManageAttachmentsParams {
  img: ImageDocumentStoreItem | null | undefined;
}

export const useManageAttachments = ({ img }: UseManageAttachmentsParams) => {
  const dispatch = useAppDispatch();

  const [attachmentToRemove, setAttachmentToRemove] = useState<RetrievedDocumentReferenceLink | null>(null);
  const [showAttachModal, setShowAttachModal] = useState<boolean>(false);
  const [showRemoveAttachmentModal, setShowRemoveAttachmentModal] = useState<boolean>(false);

  const handleStartRemovingAttachment = (attachment: RetrievedDocumentReferenceLink) => {
    setAttachmentToRemove(attachment);
    setShowRemoveAttachmentModal(true);
    setShowAttachModal(false);
  };

  const handleConfirmRemoveAttachment = () => {
    if (!img || !attachmentToRemove) return;
    dispatch(handleRemoveAttachment({ img, attachmentToRemove }));
    setAttachmentToRemove(null);
  };

  const handleToggleFavoriteLink = (params: { scopeId: number; scopeReferenceId: number; img: ImageDocumentStoreItem }) => {
    dispatch(handleToggleFavoriteLinkFn(params));
  };

  const onClose = () => {
    setShowAttachModal(false);
  };

  return {
    onClose,
    attachmentToRemove,
    setAttachmentToRemove,
    showAttachModal,
    setShowAttachModal,
    showRemoveAttachmentModal,
    setShowRemoveAttachmentModal,
    handleStartRemovingAttachment,
    handleConfirmRemoveAttachment,
    handleToggleFavoriteLink,
  };
};
